// = Libs =
import { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from '../card.module.scss';

// = Types =
import { CardBodyProps } from './card-body.types';

const CardBody: FC<CardBodyProps> = (props) => {
  const { children, className = '' } = props;

  return (
    <div
      className={clsx(
        {
          [classes.card__body]: true,
        },
        className
      )}>
      {children}
    </div>
  );
};

export default CardBody;
